import { createAction, props } from '@ngrx/store';

export const loadWebHookList = createAction(
    'WebHook Load webhook list',
    props<any>() 
)

export const loadWebHookListSuccess = createAction(
    'WebHook Load webhook list',
    props<{webHookList:any[]}>()
)

export const loadFailedTransactions = createAction(
    'Web hook failed transaction',
    props<{webHookId:string}>()
)

export const loadFailedTransactionsSuccess= createAction(
    'Web hook failed transaction success',
    props<{failedTransactions:any[]}>()
)

export const loadFailedTransactionsFailed = createAction(
    'Web hook failed transaction failed',
    props<{error:any}>()
)

export const resendFailedTransaction = createAction(
    'Web hook failed transactions resend',
    props<{webHookErrorId:string,webHookId:string}>()
)

export const resendFailedTransactionSuccess = createAction(
    'Web hook failed transactions resend success',
    props<any>()
)

export const deleteWebHook = createAction(
    'Web hook delete',
    props<{webHookId:string, onDetailsPage:boolean}>()
)

export const deleteWebHookSuccess = createAction(
    'Web hook delete success',
)

export const deleteWebHookFailure = createAction(
    'Web hook delete failure',
    props<{error:any}>()
)

export const editWebHok = createAction(
    'Web hook edit',
    props<{webHookId: string, webHook: any}>()
)

export const editWebHookSuccess = createAction(
    'Web hook edit success',
    props<any>()
)

export const editWebHookFailure = createAction(
    'Web hook edit failure',
    props<{errro: any}>()
)

export const addWebHook = createAction(
    'Add web hook',
    props<{webHookToAdd:any}>(),
)

export const addWebHookSuccess = createAction(
    'Add web hook success',
    props<{addedWebHook:any}>(),
)

export const addWebHookFailure = createAction(
    'Add web hook failure',
    props<any>(),
)

export const testSendWebHook = createAction(
    'Test send web hook',
    props<{webHookId: string}>()
)

export const testSendWebHookSuccess = createAction(
    'Test send web hook success',
)

export const testSendWebHookFailure = createAction(
    'Test send web hook failure',
    props<{error: any}>()
)